/*
 * Copyright (c) 2020  Apricot Courses, LLC. All Rights Reserved.
 */

// Landing Page
export const idSignin = "idSignin";
export const idMenu = "idMenu";
export const idLogout = "idLogout";
export const idCourses = "idCourse";
export const idProfile = "idProfile";
export const idAbout = "idAbout";
export const idSurvey = "idSurv";
export const idSupportUs = "isSupUs";
export const idExplore = "idExplore";

// Account Pages
//
export const idEyeIcon = "idEye";
// Sign In page
export const idToLogin = "idToLogin";
export const idToSignup = "idToSnUp";
// Signup Dialog
export const idTerms = "idTerms";
export const idPolicy = "idPolicy";
// Login Dialog
export const fnLoginForm = "fnLoginForm";
export const idForgetPW = "idForgetPW";
// Change Password Dialog
export const fnChgPW = "fnChgPW";
export const idShowPW = "idShowPW";
// Profile
export const fnNameForm = "fnNameForm";
export const idNameSubmit = "idNameSmt";
export const idJobSubmit = "idJobSmt";
export const idAreaSubmit = "idAreaSmt";
export const idChgPW = "idChgPW";

// Classroom
//
// SidePanel
export const idTabProg = "idTabProg";
export const idTabClip = "idTabClip";
export const idTabNote = "idTabNote";
export const idShowClip = "idShowClp";
export const idLecNext = "idLecNext";
export const idLecPrev = "idLecPrev";
export const idLecBack = "idLecBack";
export const idIBox = "idIBox";
// Player
export const idRestart = "idRestart";
export const idResume = "idResume";
// Notes
// note edit
export const idNewNtLarge = "idNewNtLarge";
export const idNewNtSmall = "idNewNtSmall";
export const idSaveNote = "idSaveNt";
export const idDelNote = "idDelNt";
export const idOpenNt = "idOpenNote"; // open a single note
export const idNtTitle = "idNtTitle";
export const idNtBody = "idNtBody";
// note control
export const idNtPlayV = "idNtPlayV";
export const idNtSetupV = "idNtSetV";
export const idNtClearV = "idNtClrV";
export const idNtClrPicker = "idNtClrPk";
export const idNtColor = "idNtColor";
// notes book controls
export const idOpenNotes = "idOpenNts"; // open notes book
export const idLargeNZ = "idLargeNZ";
export const idSmallNZ = "idSmallNZ";
export const idExpNotes = "idExpNts";
export const idFoldNotes = "idFoldNts";

// InfoBox
//
// Handout
export const idPdfDial = "idPdfDial";
export const idVideoDial = "idVideoDial";
export const idPdfZoomIn = "idPdfZi";
export const idPdfZoomOut = "idPdfZo";
export const idPdfZoomReset = "idPdfRes";
export const idPdfNext = "idPdfNext";
export const idPdfPrev = "idPdfPrev";
export const idPdfPip = "idPdfPip";
// Card
export const idCard = "idCard";
export const idCardFlip = "idCardFlp";
export const idCardNext = "idCrdNext";
export const idCardPrev = "idCrdPrev";

// MyStudy
export const idMyStudy = "idMyStd";

// SupportUs
export const idSurvTake = "idSurvTake";
export const idSurvComment = "idSurvCmt";

// Modal / General
export const idModalOK = "idModalOK";
export const idClose = "idClose";
export const idModalChk = "idModalChk";
export const idModalBtn = "idModalBtn";
export const idTestInfo = "idTestInfo";
export const idSubmit = "idSubmit";
